import { api } from "./client";

export interface IgnoredEntry {
  normalized_url: string;
  reason: string | null;
}

export const listIgnored = (limit = 200, offset = 0) =>
  api<IgnoredEntry[]>(`/api/ignore?limit=${limit}&offset=${offset}`);

export const addIgnored = (urls: string[], reason?: string | null) =>
  api<{ added: number }>("/api/ignore", {
    method: "POST",
    body: JSON.stringify({ urls, reason: reason ?? null }),
  });
